import React, { useEffect, useId, useRef, useState } from "react";
import { UncontrolledTooltip } from "reactstrap";

interface EllipsisWithTooltipProps {
  text: string;
}

export const EllipsisWithTooltip: React.FC<EllipsisWithTooltipProps> = ({
  text,
}) => {
  const [isTruncated, setIsTruncated] = useState<boolean>(false);
  const id = useId().replace(/:/g, "-");
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  return (
    <div>
      <div
        id={id}
        ref={textRef}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          cursor: isTruncated ? "pointer" : "default",
        }}
      >
        {text}
      </div>

      {isTruncated && (
        <UncontrolledTooltip target={id} placement="top">
          {text}
        </UncontrolledTooltip>
      )}
    </div>
  );
};
